// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2632":"8b09758d","5128":"cd80cc81","8320":"8b09758d","8472":"8b09758d"}[chunkId] + ".chunk.css";
};